/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BrandAndMarketRequest
 */
export interface BrandAndMarketRequest {
    /**
     * 
     * @type {number}
     * @memberof BrandAndMarketRequest
     */
    brand?: number;
    /**
     * 
     * @type {string}
     * @memberof BrandAndMarketRequest
     */
    market?: string | null;
}

export function BrandAndMarketRequestFromJSON(json: any): BrandAndMarketRequest {
    return BrandAndMarketRequestFromJSONTyped(json, false);
}

export function BrandAndMarketRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrandAndMarketRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brand': !exists(json, 'brand') ? undefined : json['brand'],
        'market': !exists(json, 'market') ? undefined : json['market'],
    };
}

export function BrandAndMarketRequestToJSON(value?: BrandAndMarketRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brand': value.brand,
        'market': value.market,
    };
}


